import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput} from '../../components'
import container from '../../helpers/container'

import Styles from './About.css'

@CSSModules(Styles)
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'About'
    const url = config.domain + config.routes.about

    const bannerImage = 'park'
    const bannerHeadline = 'About Gender Equality Funds'
    const bannerSubtitle = "We're here to help you invest your values"

    const equileapLogo = require( '../../../static/images/equileap-logo.png' )
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    const img1 = require('../../../static/images/about-1.jpg')
    const img2 = require('../../../static/images/about-2.jpg')
    const img3 = require('../../../static/images/gef-desktop.jpg')

    //
    return (
      <div>
        {container.helmet(title, '', url)}
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>
        <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='title'>
                Investing in gender equality
              </div>
              <div styleName='lede'>
                You don't have to be a financial expert to practice
                gender-lens investing.
              </div>
            </div>
          </div>
          <div styleName='x-401k-container'>
            <div styleName='x-401k-container-inner'>
              <div styleName='x-401k-info'>
                <div styleName='x-401k-info-title'>
                  Sustainable and responsible investing made easy
                </div>
                <p>
                  Gender Equality Funds is a search platform that enables you
                  to find out if your money, in the form of individual mutual
                  fund investments or an employer-provided 401(k), is invested
                  in companies leading on gender diversity and equality. You
                  can find socially responsible options that prioritize
                  companies with an equal gender balance and strong policies
                  promoting gender equality.
                </p>
                <p>
                  You can help build a more equal world by investing in
                  companies that offer women success in the workplace, without
                  sacrificing returns. A growing body of research correlates
                  various gender-lens investing criteria with higher financial
                  performance and lower investment risk.
                </p>
              </div>
              <img
                styleName='x-401k-photo'
                src={img1}
                alt='Sustainable and responsible investing made easy'
              />
            </div>
          </div>
          <div styleName='x-ays-container'>
            <div styleName='x-ays-container-inner'>
              <div styleName='x-ays-info'>
                <div styleName='x-ays-info-title'>
                  Who we are
                </div>
                <p>
                  For more than two decades, As You Sow has been promoting
                  responsible investing. As part of our <Link
                    to={config.links.aysinvest}
                    xstrong
                    title='As You Sow - Invest Your Values'
                  >Invest Your Values program</Link>, we've created a series
                  of platforms that provide free analysis and information to
                  help people avoid investments in fossil fuels, weapons,
                  tobacco, and other morally questionable products and
                  business practices.
                </p>
                <p>
                  To build <strong>Gender Equality Funds</strong>, As You Sow
                  partnered with <Link
                    to={config.links.equileap}
                    xstrong
                    title='Equileap'
                  >Equileap</Link>, a women-led social venture working to
                  accelerate progress towards gender equality as a vital lever
                  in reducing poverty and inequality.
                </p>
              </div>
              <div styleName='double-logo-wrap'>
                <div styleName='double-logo'>
                  <div styleName='logo-first-wrap'>
                    <Link
                      to={config.links.ays}
                      title='As You Sow'
                      >
                      <img
                        styleName='logo-ays'
                        src={aysLogo}
                        alt='As You Sow'
                      />
                    </Link>
                  </div>
                  <div styleName='logo-second-wrap'>
                    <Link
                      to={config.links.equileap}
                      title='Equileap'>
                      <img
                        styleName='logo-equileap'
                        src={equileapLogo}
                        alt='Equileap'
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <img
                styleName='x-ays-photo'
                src={img2}
                alt='Who we are - As You Sow'
              />
            </div>
          </div>
          <div styleName='x-desktop-container'>
            <div styleName='x-desktop-container-inner'>
              <div styleName='x-desktop-info'>
                <div styleName='x-desktop-info-title'>
                  How Gender Equality Funds works
                </div>
                <ul>
                  <li>
                    Look up mutual funds, using up-to-date fund data from
                    Morningstar
                  </li>
                  <li>
                    We cross-reference your investments, using Equileap’s
                    company gender equality scores
                  </li>
                  <li>
                    See how funds score on gender balance in leadership and
                    workforce; equal compensation and work life balance;
                    policies promoting gender equality; and commitment,
                    transparency, and accountability
                  </li>
                  <li>
                    Review the financial performance data, and compare to
                    various benchmarks
                  </li>
                </ul>
                <p>
                  <Link
                    to={config.routes.howitworks}
                    xstrong={true}
                    title='How it works'>
                      See how it works <LinkIcon />
                  </Link>``
                </p>
                <div styleName='x-desktop-info-title-2'>
                  Use our action toolkit
                </div>
                <ul>
                  <li>
                    Learn how to invest your values and get started with
                    gender lens investing
                  </li>
                  <li>
                    Push your employer to provide 401(k) options that rank
                    higher on gender equality
                  </li>
                  <li>
                    Find educational resources on the benefits of gender
                    lens investing
                  </li>
                </ul>
                <p>
                  <Link
                    to={config.routes.toolkit}
                    xstrong={true}
                    title='Action toolkit'>
                      View the action toolkit <LinkIcon/>
                  </Link>
                </p>
              </div>
              <img
                styleName='x-desktop-photo'
                src={img3}
                alt='How Gender Equality Funds works'
              />
            </div>
          </div>

          { /* Get Started Panel*/ }
          <GetStartedInput />
        </div>
      </div>
    )
  }
}
